import { RadioButtonGroup } from 'components/ui/RadioButtonWithText/RadioButtonWithTextStyles';
import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const PageOne = styled.div`
  ${RadioButtonGroup} {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    gap: 24px;
  }
`;

export const ResumeGameTooltip = styled.span`
  color: ${grey};
  font-size: 13px;
  width: 100%;
  display: block;
  text-align: center;
  margin-top: 15px;
`;

export const Description = styled.div`
  color: #414141;
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;

export const GameType = styled.div`
  color: #414141;
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
